<template>
  <div>
    
  </div>
</template>

<script>


export default {
  
  data() {
    return {
      
    };
  },

  mounted() {
    const cookie = document.cookie;
    const encodedCookie = encodeURIComponent(cookie);
    console.log("cookie", cookie);
    this.uni.reLaunch(`/control/index?cookie=${encodedCookie}`);
  },

  methods: {
    
  },
};
</script>
